import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { UpdateSolution } from "../../../../redux/services/ContentService/content.Services";
import { successToast, errorToast } from "../../../../Utils/toast";

function EditSolution() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("editSolution");
    if (!stored) {
      navigate("/solutions-list");
      return;
    }
    const data = JSON.parse(stored);
    setForm({
      id: data.id,
      name: data.name || "",
      short_description: data.short_description || "",
      long_description: data.long_description || "",
      hero_title: data.hero_title || "",
      hero_subtitle: data.hero_subtitle || "",
      hero_image: data.hero_image || "",
      meta_title: data.meta_title || "",
      meta_description: data.meta_description || "",
      status: data.status ?? 1,
      sort_order: data.sort_order ?? 0,
    });
  }, [navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await UpdateSolution(form);

      if (res?.success) {
        successToast(res?.message || "Solution updated successfully!");
        localStorage.removeItem("editSolution");
        navigate("/solutions-list");
      } else {
        errorToast(res?.message || "Failed to update solution");
      }
    } catch (err) {
      console.log(err);
      errorToast(
        err?.response?.data?.message || "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  if (!form) return <div className="p-4">Loading...</div>;

  return (
    <div>
      <div className="d-md-flex d-block align-items-center justify-content-between mt-1 page-header-breadcrumb">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="page-header">
            <div>
              <h3 className="page-title mb-0">Edit Solution</h3>
              <nav className="page-breadcrumb">
                <Link to="/">Home</Link>
                <span className="mx-2">/</span>
                <Link to="/module-list">Modules</Link>
                <span className="mx-2">/</span>
                <Link to="/solutions-list">Solutions</Link>
                <span className="mx-2">/</span>
                <span>Edit</span>
              </nav>
            </div>
          </div>

          <Link
            to="/solutions-list"
            className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
            style={{ width: "40px", height: "40px", borderRadius: "8px" }}
          >
            <FaArrowLeft />
          </Link>
        </div>
      </div>

      <div className="main_page">
        <div className="st-wrapper-card p-4">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Name *</label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Hero Title</label>
                <input
                  type="text"
                  name="hero_title"
                  value={form.hero_title}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Hero Subtitle</label>
                <input
                  type="text"
                  name="hero_subtitle"
                  value={form.hero_subtitle}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Hero Image URL</label>
                <input
                  type="text"
                  name="hero_image"
                  value={form.hero_image}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">Short Description</label>
                <textarea
                  name="short_description"
                  value={form.short_description}
                  onChange={handleChange}
                  className="form-control"
                  rows="2"
                ></textarea>
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">Long Description</label>
                <textarea
                  name="long_description"
                  value={form.long_description}
                  onChange={handleChange}
                  className="form-control"
                  rows="3"
                ></textarea>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Meta Title</label>
                <input
                  type="text"
                  name="meta_title"
                  value={form.meta_title}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Meta Description</label>
                <input
                  type="text"
                  name="meta_description"
                  value={form.meta_description}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>

            <div className="d-flex justify-content-end gap-2 mt-3">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate("/solutions-list")}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Updating..." : "Update Solution"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditSolution;